import Vue from "vue";
import vuetify from "@/plugins/vuetify";
import App from "./App.vue";
import router from "./router/index";
import "./scss/variables.scss";
import firebase from "./firebaseConfig";
import i18n from './i18n'
import store from "./store";

Vue.config.productionTip = false;



firebase.auth().onAuthStateChanged(user => {
  store.dispatch('fetchUser', user)
});

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount("#app");
